import RoleView from "../../Navigation/RoleView";
import TeachrSettingsV2 from "../../App/SettingsV2/TeachrSettingsV2";
import ClientSettingsV2 from "../../App/ClientV2/ClientSettingsV2";

/**
 * Paramètres du tableau de bord commun, version repensée (maquettes 8a à 8e) :
 * la vue prof est `TeachrSettingsV2`, la vue client `ClientSettingsV2`.
 * Les anciennes pages (`ProfilPage`, `TeachrSettings`, `ClientSettings`) sont
 * conservées dans le code.
 */
const SettingsV2Page = () => (
    <RoleView prof={<TeachrSettingsV2 />} client={<ClientSettingsV2 />} />
);

export default SettingsV2Page;
